import styled from 'styled-components';

// Constellation Components
import { spaceMixin } from '@zillow/constellation';
import { Datepicker } from '@zillow/zrs-rentals';

export const StyledDatepicker = styled(Datepicker)`
    div:nth-of-type(2){
        position: fixed;
    }
`;

export const StyledEditUnitModalDiv = styled.div`
    .EditUnitModal-switch-container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .EditUnitModal-switch {
        margin-left: ${spaceMixin('sm')};
    }
    .EditUnitModal-controls {
        padding-top: ${spaceMixin('sm')};
        text-align: right;
    }
    .EditUnitModal-cancel {
        margin-right: ${spaceMixin('sm')};
    }
`;
